import React, { useState, useEffect } from 'react';
import './GifPicker.css';

const GifPicker = ({ onSelect, onClose }) => {
  const [query, setQuery] = useState('');
  const [gifs, setGifs] = useState([]);
  const [loading, setLoading] = useState(false);
  const apiKey = import.meta.env.VITE_GIPHY_API_KEY;

  useEffect(() => {
    // Load trending GIFs on mount
    if (!apiKey) return;
    setLoading(true);
    fetch(`https://api.giphy.com/v1/gifs/trending?api_key=${apiKey}&limit=20`)
      .then(res => res.json())
      .then(data => {
        setGifs(data.data || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [apiKey]);

  const handleSearch = () => {
    if (!apiKey || !query.trim()) return;
    setLoading(true);
    fetch(`https://api.giphy.com/v1/gifs/search?api_key=${apiKey}&q=${encodeURIComponent(query)}&limit=20`)
      .then(res => res.json())
      .then(data => {
        setGifs(data.data || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  if (!apiKey) {
    return (
      <div className="gif-picker-popup">
        <div className="gif-picker-header">
          <span>GIF Picker</span>
          <button className="gif-close" onClick={onClose}>×</button>
        </div>
        <div className="gif-picker-body">
          <p style={{ padding: 16, color: '#999' }}>
            Please set VITE_GIPHY_API_KEY in your .env to enable GIF search.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="gif-picker-popup">
      <div className="gif-picker-header">
        <input
          type="text"
          placeholder="Search GIFs..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') handleSearch(); }}
          className="gif-search-input"
        />
        <button className="gif-search-btn" onClick={handleSearch}>Search</button>
        <button className="gif-close" onClick={onClose}>×</button>
      </div>
      <div className="gif-picker-body">
        {loading ? (
          <div className="gif-loading">Loading...</div>
        ) : gifs.length > 0 ? (
          <div className="gif-grid">
            {gifs.map((gif) => (
              <button
                key={gif.id}
                className="gif-item"
                onClick={() => { onSelect(gif.images.fixed_height.url); onClose(); }}
              >
                <img src={gif.images.fixed_height.url} alt={gif.title} />
              </button>
            ))}
          </div>
        ) : (
          <div className="gif-empty">No GIFs found. Try searching!</div>
        )}
      </div>
    </div>
  );
};

export default GifPicker;
